<template>
  <div class="divider">
    <div class="line"></div>
    <div v-if='title!=""' class="title">
      {{$t(title)}}
    </div>
    <div class="line"></div>
  </div>
</template>

     
<script>

export default {
  name: 'divider',
  props:{
    title:{default:""},
  },
  data:function(){
    return {
    }
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .divider{
    display:flex;
    padding-bottom:12px;
    padding-top:12px;
    align-items:center;
    
  }
  
  .line{
    border:1px solid #EEEEEE;
    border-bottom:1px solid #999999;
    flex:1;
  }
  .title{
    font-weight: bold;
    font-size: 1.25em;
    padding: 5px 10px;
   
    
   
  }
</style>
